import Box from "@mui/material/Box";

import Typography from "@mui/material/Typography";

import Grid from "@mui/material/Grid";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Role from "../../../../utils/interfaces/IRole";
import "../../../../App.scss";
import "./role-info.scss";
import PopperComponent from "../popper";
import { isMobile } from "../../../../utils/screenValidations/screen";

type TypeRoleInfoDescription = {
    selectedRole: Role | null;
};

const RoleInfoDescription = ({ selectedRole }: TypeRoleInfoDescription) => {
    return (
        <Box className="boxDescription">
            <List disablePadding>
                <ListItem disablePadding style={{ marginBottom: "24px" }}>
                    <Grid container direction="column">
                        <Grid item>
                            <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
                                <Typography fontFamily="IliaMontSerratBold" fontWeight="700" color="#9192AD" fontSize="14px" lineHeight="17.07px">
                                    Área
                                </Typography>
                                <PopperComponent isDetails={isMobile()} text="Refere-se ao setor ou departamento específico dentro da empresa." />
                            </Box>
                        </Grid>
                        <Grid item>
                            {selectedRole?.areas.map((area, index) => (
                                <Typography
                                    key={index}
                                    fontFamily="IliaOpenSansSemibold"
                                    color="#F7F7FF"
                                    fontSize="16px"
                                    fontWeight="600"
                                    lineHeight="21.79px"
                                >
                                    {area.name}
                                </Typography>
                            ))}
                        </Grid>
                    </Grid>
                </ListItem>
                <ListItem disablePadding style={{ marginBottom: "24px" }}>
                    <Grid container direction="column">
                        <Grid item>
                            <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
                                <Typography fontFamily="IliaMontSerratBold" fontWeight="700" color="#9192AD" fontSize="14px" lineHeight="17.07px">
                                    Perfil{" "}
                                </Typography>
                                <PopperComponent isDetails={isMobile()} text="Define a abordagem de trabalho do profissional, seja analítica, tática, operacional ou estratégica." />
                            </Box>
                        </Grid>
                        <Grid item>
                            <Typography fontFamily="IliaOpenSansSemibold" color="#F7F7FF" fontWeight="600" fontSize="16px" lineHeight="21.79px">
                                {selectedRole?.profile.name}
                            </Typography>
                        </Grid>
                    </Grid>
                </ListItem>
                <ListItem disablePadding style={{ marginBottom: "24px" }}>
                    <Grid container direction="column">
                        <Grid item>
                            <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
                                <Typography fontFamily="IliaMontSerratBold" fontWeight="700" color="#9192AD" fontSize="14px" lineHeight="17.07px">
                                    Trajetórias Possíveis{" "}
                                </Typography>
                                <PopperComponent isDetails={isMobile()} text="Indica os caminhos de carreira que um profissional pode seguir dentro da empresa, partindo do cargo atual para posições de maior responsabilidade ou especialização." />
                            </Box>
                        </Grid>
                        <Grid item>
                            <Typography fontFamily="IliaOpenSansSemibold" color="#F7F7FF" fontWeight="600" fontSize="16px" lineHeight="21.79px">
                                {selectedRole?.trajectory.trajectory}
                            </Typography>
                        </Grid>
                    </Grid>
                </ListItem>
                <ListItem disablePadding style={{ marginBottom: "24px" }}>
                    <Grid container direction="column">
                        <Grid item>
                            <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
                                <Typography fontFamily="IliaMontSerratBold" fontWeight="700" color="#9192AD" fontSize="14px" lineHeight="17.07px">
                                    Mercado{" "}
                                </Typography>
                                <PopperComponent isDetails={isMobile()} text="Refere-se ao setor em que a empresa atua e as tendências de mercado que podem influenciar as oportunidades de carreira e desenvolvimento profissional." />
                            </Box>
                        </Grid>
                        <Grid item>
                            <div>
                                <Typography fontFamily="IliaOpenSansSemibold" color="#F7F7FF" fontSize="16px" fontWeight="600" lineHeight="21.79px">
                                    {selectedRole?.markets.map((market) => market.market).join(", ")}
                                </Typography>
                            </div>
                        </Grid>
                    </Grid>
                </ListItem>
                <ListItem disablePadding style={{ marginBottom: "24px" }}>
                    <Grid container direction="column">
                        <Grid item>
                            <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
                                <Typography fontFamily="IliaMontSerratBold" fontWeight="700" color="#9192AD" fontSize="14px" lineHeight="17.07px">
                                    Descrição do Cargo{" "}
                                </Typography>
                                <PopperComponent isDetails={isMobile()} text="Fornece um resumo das principais funções, responsabilidades e objetivos associados ao cargo." />
                            </Box>
                        </Grid>
                        <Grid item>
                            <Typography fontFamily="IliaOpenSansSemibold" color="#F7F7FF" fontWeight="600" fontSize="16px" lineHeight="21.79px">
                                {selectedRole?.description}
                            </Typography>
                        </Grid>
                    </Grid>
                </ListItem>
                <ListItem disablePadding>
                    <Grid container direction="column">
                        <Grid item>
                            <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
                                <Typography fontFamily="IliaMontSerratBold" fontWeight="700" color="#9192AD" fontSize="14px" lineHeight="17.07px">
                                    Cargo com maior proximidade{" "}
                                </Typography>
                                <PopperComponent isDetails={isMobile()} text="Lista os cargos dentro da empresa que têm uma relação estreita ou complementar ao cargo em questão." />
                            </Box>
                        </Grid>
                        <Grid item>
                            <Typography fontFamily="IliaOpenSansSemibold" color="#F7F7FF" fontWeight="600" fontSize="16px" lineHeight="21.79px">
                                {selectedRole?.related_roles.map((el) => el.role).join(", ")}
                            </Typography>
                        </Grid>
                    </Grid>
                </ListItem>
            </List>
        </Box>
    );
};

export default RoleInfoDescription;
